import React from 'react';
import millify from 'millify';
import { twMerge } from 'tailwind-merge';

export const StatsInfo = ({
  total,
  label,
  onClick,
  loading,
}: {
  total: number;
  label: string;
  onClick?: () => void;
  loading?: boolean;
}) => {
  if (loading) {
    return (
      <div className="flex flex-col">
        <div className="my-0.5 h-4 w-9 animate-pulse rounded-md bg-neutral200" />
        <div className="my-0.5 h-4 w-14 animate-pulse rounded-md bg-neutral200" />
      </div>
    );
  }

  return (
    <div
      className={twMerge(
        'flex min-w-[55px] flex-col items-start',
        !!onClick && 'group cursor-pointer',
      )}
      onClick={onClick}
    >
      <h3 className="font-title text-title-s font-medium text-base800 group-hover:text-black md:text-title-m">
        {millify(total)}
      </h3>
      <p className="font-base text-base-s font-medium capitalize text-base400 group-hover:text-base500 md:text-base-m">
        {label}
      </p>
    </div>
  );
};
